<template>
  <!-- funcView.get_list -->
  <div class="device-maps-bd">
    <div class="device-map-bd">
      <!-- <div class="device-aside ubv" v-if="false">
        <div class="info">
          <h1>{{ $t('page_content_device_total') }}</h1>
          <p>{{ count.total }}</p>
          <ul class="ubw" style="margin-bottom: 8px">
            <li :class="{ cur: formSearch.state === item.code }" v-for="item in stateList" :key="item.code" @click="onStateItem(item.code)">
              <div style="position: relative">
                <div class="ub" style="width: 75px">
                  <i :class="item.icon"></i>
                  <span class="line1" style="width: 90px">{{ $t(item.lang) }}</span>
                </div>
                <el-tooltip :disabled="count[item.code] == '0'" :content="`${count[item.code]}`" placement="top">
                  <div class="line1" style="position: absolute; top: 0; bottom: 0; right: 0; max-width: 28px">
                    {{ count[item.code] }}
                  </div>
                </el-tooltip>
              </div>
            </li>
          </ul>
          <ul class="ubw" style="margin-bottom: 8px">
            <li :class="{ cur: formSearch.state === item.code }" v-for="item in stateList1" :key="item.code" @click="onStateItem(item.code)">
              <div style="position: relative">
                <div class="ub" style="width: 75px">
                  <i :class="item.icon"></i>
                  <span class="line1" style="width: 90px">{{ $t(item.lang) }}</span>
                </div>
                <el-tooltip :disabled="count[item.code] == '0'" :content="`${count[item.code]}`" placement="top">
                  <div class="line1" style="position: absolute; top: 0; bottom: 0; right: 0; max-width: 28px">{{ count[item.code] }}</div>
                </el-tooltip>
              </div>
            </li>
          </ul>
          <el-input :placeholder="$t('placeholder_body_num')" v-model="formSearch.search" @input="getDevicePage" style="width: 100%" clearable></el-input>
        </div>
        <div class="ub-f1 table-wrap">
          <custom-table
            height="100%"
            type="radio"
            ref="tb1"
            @on-row-click="onClickRow"
            :data="devicePageList"
            :row-class-name="rowClassName"
            tableCode="device_map"
            @sort="sortChange"
            @filter="filterChange"
            :slots="['attachPath', 'bodyNum']"
          >
            <template slot="attachPath" slot-scope="scope">
              <div class="box" style="text-align: center">
                <img style="width: 32px; height: 32px; display: block; margin: 0 auto" :src="getAttachUrl(scope.row)" />
              </div>
            </template>
            <template slot="bodyNum" slot-scope="scope">
              <span class="cell-link" @click="jump('/devicedetail', { deviceId: scope.row.deviceId, parentPath: $route.path })">{{ scope.row.bodyNum }}</span>
            </template>
          </custom-table>
        </div>
        <div class="table-page">
          <custom-page style="text-align: center" layout="prev,pager,next" :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
        </div>
      </div> -->
      <div class="device-section ub-f1" :class="{ 'full-screen': fullScreen }">
        <!-- 地图 -->
        <div id="container" style="width: 100%; height: 100%; border-radius: 8px"></div>
        <!-- scale组件 -->
        <!-- <div class="amap-tool" v-if="`${this.mapType}` === '1'">
        <div class="zoom ubv">
          <div class="ub-f1" @click="toolHandle('add')">
            <i class="icon icon-shebeiyewuxinxi1"></i>
          </div>
          <div class="bar"></div>
          <div class="ub-f1" @click="toolHandle('reduce')">
            <i class="icon icon-shebeiyewuxinxi11"></i>
          </div>
        </div>
      </div>
      <div class="full-btn" @click="fullScreen = !fullScreen" v-if="`${this.mapType}` === '1'">
        <i v-if="!fullScreen" class="icon icon-quanping2"></i>
        <i v-if="fullScreen" class="icon icon-quanping11"></i>
      </div> -->
      </div>
      <!-- 左边滑块 -->
      <div class="drawer-left-btn show" v-show="!visibleLeftSide" @click="visibleLeftSide = !visibleLeftSide">
        <i class="icon icon-huadongjiesuo" :class="{ show: visibleLeftSide }"></i>
      </div>
      <transition name="drawer-left">
        <div class="drawer-left-container" v-show="visibleLeftSide">
          <div class="drawer-left-wrap">
            <div class="drawer-left-btn" @click="visibleLeftSide = !visibleLeftSide">
              <i class="icon icon-huadongjiesuo" :class="{ show: visibleLeftSide }"></i>
            </div>
            <div class="ubv" style="height: 100%">
              <div class="tit ub ub-sp" :class="{ cur: !formSearch.state && otherState.length === 0 }" @click="onDeviceAll">
                <div class="ub ub-xc">
                  <img v-if="!formSearch.state && otherState.length === 0" src="../../../images/map/tit1.svg" alt="" />
                  <img v-else src="../../../images/map/tit.svg" alt="" />
                  <span>{{ $t('dms_device_map.zong_shu') }}</span>
                </div>
                <div>{{ count.total }}</div>
              </div>
              <div class="sub-tit">{{ $t('dms_device_map.yun_xing_zhuang_tai') }}</div>
              <div class="states">
                <ul>
                  <li v-for="item in stateList" :key="item.code">
                    <div class="ub ub-sp" :class="{ cur: formSearch.state === item.code }" @click="onStateItem(item.code)">
                      <div class="ub ub-xc" :class="item.code">
                        <span class="dit"></span>
                        <span class="label">{{ item.name }}</span>
                      </div>
                      <div>{{ count[item.code] }}</div>
                    </div>
                    <div class="sub-states" v-if="item.children">
                      <ul>
                        <li v-for="sub in item.children" :key="sub.code">
                          <div class="ub ub-sp" :class="{ cur: formSearch.state === sub.code }" @click="onStateItem(sub.code)">
                            <div class="ub ub-xc" :class="sub.code">
                              <span class="rect"></span>
                              <span class="label" style="font-weight: normal">{{ sub.name }}</span>
                            </div>
                            <div>{{ count[sub.code] }}</div>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </li>
                  <li style="margin-bottom: 10px">
                    <div class="ub" :class="{ cur: otherState.length > 0 }">
                      <el-dropdown style="width: 100%" trigger="click" :hide-on-click="false">
                        <span class="el-dropdown-link">
                          <span class="dit" style="opacity: 0"></span>
                          <span class="label">{{ $t('dms_device_map.qi_ta') }}</span>
                          <i style="float: right; padding-left: 120px" class="icon icon-xiala"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown" class="menu-map">
                          <el-dropdown-item
                            v-for="item in stateList1"
                            :key="item.code"
                            class="ub ub-sp"
                            style="height: 30px; margin-bottom: 2px"
                            :class="{ cur: otherState.includes(item.code) }"
                            @click.native="onOtherStateItem(item.code)"
                          >
                            <div style="width: 150px">
                              <span>{{ item.name }}</span>
                            </div>
                            <div>{{ count[item.code] }}</div>
                          </el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                    </div>
                  </li>
                </ul>
              </div>
              <div class="sub-tit">{{ $t('dms_device_map.she_bei_xing_hao') }}</div>
              <div class="types">
                <ul>
                  <li v-for="item in count.productCountList" :key="item.productCode" class="ub ub-sp" :class="{ cur: productCode.includes(item.productCode) }" @click="onProductItem(item.productCode)">
                    <div class="ub ub-xc">
                      <div class="img-box">
                        <img :src="getAttachUrl(item)" />
                      </div>
                      <span class="label">{{ item.productCode }}</span>
                    </div>
                    <div>{{ item.deviceNum }}</div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </transition>
      <!-- 右边滑块 -->
      <div class="drawer-right-btn show" v-show="!visibleRightSide" @click="visibleRightSide = !visibleRightSide">
        <i class="icon icon-huadongjiesuo" :class="{ show: visibleRightSide }"></i>
      </div>
      <transition name="drawer-right">
        <div class="drawer-right-container" v-show="visibleRightSide">
          <div class="drawer-right-wrap">
            <div class="drawer-right-btn" @click="visibleRightSide = !visibleRightSide">
              <i class="icon icon-huadongjiesuo" :class="{ show: visibleRightSide }"></i>
            </div>
            <div class="ubv" style="height: 100%">
              <div class="tit">{{ $t('dms_device_map.she_bei_lie_biao') }}（{{ totalRows }}）</div>
              <div class="filter">
                <el-input size="medium" :placeholder="$t('dms_device_map.cpxhjshModemSN')" v-model="formSearch.search" @input="onSearch" style="width: 100%" clearable>
                  <i slot="prefix" class="el-input__icon el-icon-search"></i>
                </el-input>
              </div>
              <div class="devices ub-f1">
                <ul>
                  <li v-for="item in devicePageList" :key="item.deviceId" :class="{ pos: item.lat && item.lng }" @click="onClickDevicePos(item)">
                    <div class="ub">
                      <div class="box" style="text-align: center">
                        <img style="width: 32px; height: 32px; display: block" :src="getAttachUrl(item)" />
                      </div>
                      <div class="ub-f1">
                        <h1>
                          {{ item.bodyNum }}
                          <span>{{ item.productCode }}</span>
                        </h1>
                        <div class="about">
                          <span class="ub ub-xc">
                            <i class="icon icon-dianliang"></i>
                            <span>{{ item.batteryCharge ? `${item.batteryCharge}%` : '--' }}</span>
                          </span>
                          <span class="ub ub-xc">
                            <i class="icon icon-wifi" v-if="`${item.networkType}` === '1'"></i>
                            <i class="icon icon-xinhao" v-else></i>
                            <!-- <span>{{ item.signal && item.signal > -1 ? `${item.signal}%` : '--' }}</span> -->
                            {{ getDicValue('dms_device_cellular_mode', item.cellularMode) || '--' }}
                          </span>
                          <span class="ub ub-xc">
                            <i class="icon icon-wendu"></i>
                            <span>{{ item.batteryTemp ? `${$celsiusToFahrenheit(item.batteryTemp)}${$formatTempUnit()}` : '--' }}</span>
                          </span>
                          <span class="err" v-if="item.isMalfunction">
                            <i class="icon icon-jinggao"></i>
                          </span>
                          <span class="eco" v-if="item.isPowerSave && !item.isMalfunction">
                            <i class="icon icon-eco"></i>
                          </span>
                          <span class="lock" v-if="item.lockState">
                            <i class="icon icon-lock"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
              <div class="pages">
                <el-pagination small layout="prev, pager, next" :total="totalRows" :current-page="formSearch.pageNum" :page-size="formSearch.pageSize" @current-change="onPageChange2"></el-pagination>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import Cookies from 'js-cookie';
import MarkerClusterer from '@googlemaps/markerclustererplus';
import apis from '@/utils/apis';
import Vue from 'vue';
import InfoWindowContent from './InfoWindowContent.vue';

window._AMapSecurityConfig = {
  securityJsCode: '2b49c28e6f2963856e974e243277e747',
};

var map;
var showInfoWindow;
var showMarker;
var pi = 3.14159265358979324;
var a = 6378245.0;
var ee = 0.00669342162296594323;
var languageMap = {
  // langcode映射谷歌地图language
  CN: 'zh-CN',
  EN: 'en-hk',
};
export default {
  name: 'devicemap',
  data() {
    return {
      visibleLeftSide: true,
      visibleRightSide: false,
      provide: true,
      showTab: 'location',
      current: {},
      otherState: [],
      productCode: [],
      formSearch: {
        search: '',
        state: '',
        otherState: '',
        productCode: '',
        pageNum: 1,
        pageSize: 20,
      },
      fullScreen: false, // 是否全屏
      count: {},
      totalRows: 0,
      devicePageList: [],
      deviceList: [],
      deviceInfoList: [],
      mapType: '', // 1-高德   4-谷歌
      mapRegion: '', // 谷歌地图 本地化区域
      mapLanguage: '', // 谷歌地图 地图多语言,
    };
  },
  computed: {
    stateList() {
      return [
        {
          name: this.$t('dms_device_map.yun_xing_zhong'),
          code: 'using',
          children: [
            {
              name: this.$t('dms_device_map.zhi_neng_qing_jie'),
              code: 'autonomous',
            },
            {
              name: this.$t('dms_device_map.ren_gong_qing_jie'),
              code: 'running',
            },
            {
              name: this.$t('dms_device_map.jiao_xue'),
              code: 'training',
            },
          ],
        },
        {
          name: this.$t('dms_device_map.kong_xian'),
          code: 'idle',
        },
        {
          name: this.$t('dms_device_map.chong_dian'),
          code: 'charging',
        },
        {
          name: this.$t('dms_device_map.li_xian'),
          code: 'offline',
        },
        {
          name: this.$t('dms_device_map.xu_xie_zhu'),
          code: 'assist',
        },
      ];
    },
    stateList1() {
      return [
        {
          name: this.$t('dms_device_map.suo_ji'),
          code: 'locked',
        },
        {
          name: this.$t('dms_device_map.gu_zhang'),
          code: 'malfunction',
        },
        {
          name: this.$t('dms_device_map.jie_neng'),
          code: 'powerSave',
        },
      ];
    },
  },
  mounted: function () {
    const langCode = Cookies.get('langCode') || 'CN';
    this.mapLanguage = languageMap[langCode];
    this.mapType = Cookies.get('mapType') || '1';
    this.mapRegion = Cookies.get('mapRegion') || 'HK';

    this.getDeviceCount();
    this.getFuncView();
    this.initMap(() => {
      this.getDevicePage();
      this.getDeviceList();
    });
  },
  methods: {
    // 跳转设备详情
    toDeviceDetail(row) {
      this.jump('/devicedetail', {
        deviceId: row.deviceId,
        parentPath: this.$route.fullPath,
      });
    },
    onDeviceAll() {
      this.formSearch.state = '';
      this.formSearch.otherState = '';
      this.formSearch.productCode = '';
      this.otherState = [];
      this.productCode = [];
      this.getDeviceList();
      this.onPageChange({ page: 1 });
    },
    onClickDevicePos(item) {
      this.jump('/devicedetail', {
        deviceId: item.deviceId,
        parentPath: this.$route.fullPath,
      });
      // if (!item.lat || !item.lng) {
      //   return;
      // }
      // if (`${this.mapType}` === '4') {
      //   let position = { lat: item.lat, lng: item.lng };
      //   if (this.mapRegion === 'HK' || this.mapRegion === 'CN' || this.mapRegion === 'MO') {
      //     const wgs = this.wgs_gcj_encrypts(item.lat, item.lng);
      //     position = { lat: wgs.lat, lng: wgs.lon };
      //   }
      //   map.setCenter(position);
      //   map.setZoom(18);

      // } else if (`${this.mapType}` === '1') {
      //   const point = this.wgs_gcj_encrypts(item.lat, item.lng);
      //   const lnglat = [point.lon, point.lat];
      //   map.setCenter(lnglat);
      //   map.setZoom(18);
      // }
    },
    transformLon(x, y) {
      var ret = 300.0 + x + 2.0 * y + 0.1 * x * x + 0.1 * x * y + 0.1 * Math.sqrt(Math.abs(x));
      ret += ((20.0 * Math.sin(6.0 * x * pi) + 20.0 * Math.sin(2.0 * x * pi)) * 2.0) / 3.0;
      ret += ((20.0 * Math.sin(x * pi) + 40.0 * Math.sin((x / 3.0) * pi)) * 2.0) / 3.0;
      ret += ((150.0 * Math.sin((x / 12.0) * pi) + 300.0 * Math.sin((x / 30.0) * pi)) * 2.0) / 3.0;
      return ret;
    },
    transformLat(x, y) {
      var ret = -100.0 + 2.0 * x + 3.0 * y + 0.2 * y * y + 0.1 * x * y + 0.2 * Math.sqrt(Math.abs(x));
      ret += ((20.0 * Math.sin(6.0 * x * pi) + 20.0 * Math.sin(2.0 * x * pi)) * 2.0) / 3.0;
      ret += ((20.0 * Math.sin(y * pi) + 40.0 * Math.sin((y / 3.0) * pi)) * 2.0) / 3.0;
      ret += ((160.0 * Math.sin((y / 12.0) * pi) + 320 * Math.sin((y * pi) / 30.0)) * 2.0) / 3.0;
      return ret;
    },
    outOfChina(lat, lon) {
      if (lon < 72.004 || lon > 137.8347) {
        return true;
      }
      if (lat < 0.8293 || lat > 55.8271) {
        return true;
      }
      return false;
    },
    // 表格化class
    rowClassName: function ({ row }) {
      return !row.lng || !row.lat ? 'exit' : '';
    },
    // 国际坐标=>中国坐标
    wgs_gcj_encrypts: function (wgLat, wgLon) {
      var point = {};
      if (this.outOfChina(wgLat, wgLon)) {
        point.lat = wgLat;
        point.lng = wgLon;
        return point;
      }
      var dLat = this.transformLat(wgLon - 105.0, wgLat - 35.0);
      var dLon = this.transformLon(wgLon - 105.0, wgLat - 35.0);
      var radLat = (wgLat / 180.0) * pi;
      var magic = Math.sin(radLat);
      magic = 1 - ee * magic * magic;
      var sqrtMagic = Math.sqrt(magic);
      dLat = (dLat * 180.0) / (((a * (1 - ee)) / (magic * sqrtMagic)) * pi);
      dLon = (dLon * 180.0) / ((a / sqrtMagic) * Math.cos(radLat) * pi);
      var lat = wgLat + dLat;
      var lon = wgLon + dLon;
      point.lat = lat;
      point.lon = lon;
      return point;
    },
    // 初始化地图
    initMap: function (cb) {
      if (`${this.mapType}` === '4') {
        this.inintGoogleMap(cb);
      } else if (`${this.mapType}` === '1') {
        this.initAMap(cb);
      }
    },
    // 初始化(高德地图)
    initAMap: function (cb) {
      cb = cb || function () {};
      const { center, zoom } = this.$getAMapCenterZoom();
      if (window.AMap) {
        map = new window.AMap.Map('container', { center, zoom, mapStyle: 'amap://styles/whitesmoke' });
        cb();
        return;
      }
      this.$loadJS('https://webapi.amap.com/maps?v=2.0&key=f94794d8324cc241ee358e7985a6f2d3', () => {
        map = new window.AMap.Map('container', { center, zoom, mapStyle: 'amap://styles/whitesmoke' });
        cb();
      });
    },
    // 初始化(谷歌地图)
    inintGoogleMap: function (cb) {
      cb = cb || function () {};
      const { center, zoom } = this.$getGMapCenterZoom();
      if (window.google) {
        map = new window.google.maps.Map(document.getElementById('container'), { center, zoom, mapTypeId: 'roadmap' });
        cb();
        return;
      }
      this.$loadJS(`https://maps.googleapis.com/maps/api/js?key=AIzaSyCFJUNQ5om8G9WFr0TYMx4mA6-Gx7UiOYA&region=${this.mapRegion}&language=${this.mapLanguage}`, ({ google }) => {
        map = new google.maps.Map(document.getElementById('container'), { center, zoom, mapTypeId: 'roadmap' });
        cb();
      });
    },
    // 搜索
    onSearch() {
      this.getDeviceList();
      this.onPageChange({ page: 1 });
    },
    // 获取设备分页
    getDevicePage: function () {
      this.formSearch.otherState = this.otherState.join(',');
      this.formSearch.productCode = this.productCode.join(',');
      this.$getJSON(apis.MyDevicePage, this.formSearch).then(async (res) => {
        this.totalRows = res.data.total;
        const deviceList = res.data.list || [];
        this.devicePageList = await this.formatAttachList(deviceList, 'productCodeId', 'dms.product.icon');
      });
    },
    // 获取设备列表
    getDeviceList: function () {
      this.initMap();
      this.formSearch.otherState = this.otherState.join(',');
      this.formSearch.productCode = this.productCode.join(',');
      // 不分页数据
      this.$getJSON(apis.MyDeviceList, { search: this.formSearch.search, state: this.formSearch.state, otherState: this.formSearch.otherState, productCode: this.formSearch.productCode }).then(
        async (res) => {
          const deviceList = res.data;
          const list = await this.formatAttachList(deviceList, 'productCodeId', 'dms.product.icon');
          this.deviceList = list;
          if (`${this.mapType}` === '4') {
            this.initDeviceGMap(list);
          } else if (`${this.mapType}` === '1') {
            this.initDeviceAMap(list);
          }
        }
      );
    },
    // 打开弹窗(高德地图)
    openInfoWindow: async function (item) {
      if (!item.location) {
        item.location = (await this.getGeoCode(item.lnglat).catch(() => {})) || this.$t('dms_device_map.wei_zhi_di_zhi');
      }
      if (showInfoWindow && showInfoWindow.close) {
        showInfoWindow.close();
      }
      const container = document.createElement('div');
      const ComponentClass = Vue.extend(InfoWindowContent);
      const vm = new ComponentClass({ propsData: { item, toDeviceDetail: this.toDeviceDetail, _this: this } }).$mount();
      container.appendChild(vm.$el);
      const infoWindow = new window.AMap.InfoWindow({
        offset: new window.AMap.Pixel(0, -58),
        content: container,
      });
      showInfoWindow = infoWindow;
      infoWindow.open(map, item.lnglat);
      if (infoWindow.on) {
        infoWindow.on('close', () => {
          vm.$destroy();
          if (container.parentNode) {
            container.parentNode.removeChild(container);
          }
        });
      }
    },
    // 打开弹窗(谷歌地图)
    openGoogleInfoWindow: async function (item, marker) {
      if (showInfoWindow && showInfoWindow.close) {
        showInfoWindow.close();
      }
      if (!item.location) {
        item.location = (await this.getGoogleCode(item).catch(() => {})) || 'Unknown address';
      }
      const container = document.createElement('div');
      const ComponentClass = Vue.extend(InfoWindowContent);
      const vm = new ComponentClass({ propsData: { item, toDeviceDetail: this.toDeviceDetail, _this: this } }).$mount();
      container.appendChild(vm.$el);
      const infoWindow = new window.google.maps.InfoWindow({
        content: container,
      });
      showInfoWindow = infoWindow;
      infoWindow.open(map, marker);
      if (infoWindow.addListener) {
        infoWindow.addListener('closeclick', () => {
          vm.$destroy();
          if (container.parentNode) {
            container.parentNode.removeChild(container);
          }
        });
      }
    },
    // 渲染设备(高德地图)
    initDeviceAMap: function (points) {
      const _this = this;
      points = points.filter((t) => t.lat && t.lng);
      points.forEach((item) => {
        const point = this.wgs_gcj_encrypts(item.lat, item.lng);
        item.lnglat = [point.lon, point.lat];
      });
      // 自定义非聚合点样式
      var _renderMarker = function (context) {
        const item = context.data[0];
        var content = `<div class="map-marker"><div class="marker ${item.currentState}"></div></div>`;
        var offset = new window.AMap.Pixel(-20, -58);
        context.marker.setContent(content);
        context.marker.setOffset(offset);
        context.marker.on('click', () => {
          _this.openInfoWindow(item);
        });
      };
      // 自定义聚合点样式
      var _renderClusterMarker = function (context) {
        var clusterCount = context.count; // 聚合中点个数
        var content = `<div class="map-cluster-marker"><div class="marker"><div class="marker-num">${clusterCount}</div></div><div class="marker-block"></div></div>`;
        var offset = new window.AMap.Pixel(-16, -7);
        context.marker.setContent(content);
        context.marker.setOffset(offset);
        context.marker.on('click', () => {
          map.setCenter(context.marker._position);
          const zoom = map.getZoom();
          map.setZoom(zoom + 4);
        });
      };
      map.plugin(['AMap.MarkerCluster'], () => {
        const markerCluster = new window.AMap.MarkerCluster(map, points, {
          gridSize: 60, // 聚合网格像素大小
          renderMarker: _renderMarker, // 自定义非聚合点样式
          renderClusterMarker: _renderClusterMarker, // 自定义聚合点样式
        });
        console.warn(markerCluster);
      });
    },
    // 渲染设备（谷歌地图）
    initDeviceGMap: function (points) {
      const _this = this;
      points = points.filter((t) => t.lat && t.lng);
      const markers = points.map((point) => {
        let position;
        // 国内/香港/澳门需要做坐标转换
        if (this.mapRegion === 'HK' || this.mapRegion === 'CN' || this.mapRegion === 'MO') {
          const wgs = this.wgs_gcj_encrypts(point.lat, point.lng);
          position = { lat: wgs.lat, lng: wgs.lon };
        } else {
          position = { lat: point.lat, lng: point.lng };
        }
        // eslint-disable-next-line max-len
        const idle = 'data:image/png;base64,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';
        // eslint-disable-next-line max-len
        const charging = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAAB0CAYAAAASLLWNAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAABW5SURBVHgB7Z3Lj1xVfsfPrap2+wHYBgOyBXabWCgDYozlLLJJ3CiLBMRozAIpO3vyD+CRIiFF0bhZZTmeLFkAs4WFbYnFbBK3k8VIaCwYkBiBRrhskC2wwW3AXd1dVffO93Pu+ZVvl6vuvfXo7mprftLxfZ17Ht/ze59b7chtICVJskuHWZUDKs+rzITiMkejBZV65nhFZV7loyiKFtwGUeTWkTKAUX7u7gVpWKq7FMzzHDcS0DUhATerclblVrI+9LbKcbeZCW5TOb2OoPWiyyonVGbcZqFkMoDrpssqp92kkwZ5Mgx2Uumyygk3aaRBzahcSDYPoY9n3CSQBvJaMlniWpYY88jcOLQbk6QuCXrllBuF7tSduznv3O2PdC7XblHXzYX0mKXtM85N7UqPu+Qy7jysouOOGTcinZHb80s3JA0FYJKy/1mXOr+D0415566fc+7a+XuBGpQAdM+sXHEx06OzbkjS6rlXBGTdDUgDAxjAu+AGdYLhqj//RuVMer4WBJg/mROgx4bhzLrKC4OCOBCAQ4G3HsB1E6J+4KRzf/PaoEDW3YAglgZwKPAA7k9z6wdcNxlHHhjIVtTdACCWAnBg8NBrf/hFahwmgQDyHy4Mwo11VxLEiitHGIyZUjXhuv85MjngQSzo/x5Jx1aOZlTOBk8jlwoBVCO/dmWt7cfyBj4+tXEim0eMibH96Y2ybzDnwvAvV4QF3kkd3nZl6JJE9so7blPQ/pPO/V25aYl+KVE+0+9hXwCD3vtQpZCNvcjiCG8mwgn/pw/L1EScjvTTh3kijOgWgwfnbTbwIMaMoSsmMOjLrj0BDKJbnJBEn2wWse1FV99J9XYxzfaLm3uKsCpfdkVWF4v28Whh8MTQT6XiDr1WVKvuUlFeZSHv4cAkTTzOuDzCLcBBvl+IuZDUyKcZ1yNxsooDSzvMvzs4ehJg0oiExD9eKKoF9x3McmE3B866IvDQefcbeBCOf7GjjUFZxYXdHJiv+wDu/164PwGESEL8y+X02J8WxIG77aLDgUm6DTiT96ZfoUkGb6rY68olyxzlE5tms3aRFeF8twXgJtFlIVFgSdWf3UqTBqNQubRbx2R7EQ5B863cVwDvUinHc7xk4JDG337gbmo/L7My6lhJgf0kNwzuGBMDEO47m/fGulpeANt3PM3jDSuWcFI5J/leos+f3SqqdVwAnq/ZRW5V9jDWGjwGjTN76NTougw6FLJC5bMvd4n3mHP+HousqTtvOvBYXk0f8qwlARzWD9EZB3hGxaLYn66fL6rBx1EuKqX/1kp80WdH3x5lN201wTm9FuD3r6S7gIMQY2NR82k3HPh8bhWAWwvwLJ00CngAhgNsKqYf9w7TB+0Vh3fH0IGzuVUW/ujGToBH2DSMuALald+moO06XE5n3hjStbl5sWgf5SAA5tYYe64P0fj7s4OBZ6BdC2KIXivOntwlgBiG/Nxzd/QOA+CBvBpuoVTWtjyh88rujtkXDIAH1wLcoOJIG8Pu0RSrrhkAzGeFxStubMRmdxkAcIQBDf2GTwjHDqsrb4+ggkqkuIpFeJw7bH97Or+f7BcMAEdYNqqFvjag9e0eUwGV4MC6GwsBSC/R7QYOUf3pr8fn2oyyP11ShNeHEN9ugjsIt8wFAbhDm2ubYP0A3JMJdhY+SoEz7iDuxbiMMwpZJ1ofAHFdTHyJTW0/BcAAbt9xt1kJAOsuz5Aw+XF8BAnXZfeQ0YmDuDQbQYw7nxaKOXAcYsUC/P8Ld60aTjBbiaMQbaFDzc3yecNj412Q4rnXS3DggdGjkSwHj2ooij7Y5LsXHO5xAFnchufAfE95x0E3NkJke1njssRCkFnJLqiJmS0SqTeMEz7kqD7szueLatTJxuSzF1/Dj4NGBQ/C+Bh4qAGyxqScrFjuz1TGqJKzq3DuVwCwnltlHA6tT8+fdCORhXcQQKFDszrKPuc9Gr4DAsRhU/pGDxVy4DwAzudWsV2vUag2BkNkIZkB1Y9YqL0/T89HEeGs69WfPqqxs6SsdN3lGRI46M8jWE30UhlXiMn3+yDcUlJlOPnAL8qk5POpWPLqYGduDL31T7CxoqMACKHYEbleroGBSx1Etdc3KsZNZaRhaqcbmfafKKoxzz+1zEV/AFkNJj6sSJTZ+wA4C++IVvb02edaj++vGW8xB3qdkt1YZwelv7LKhmCD0j9fLueXkfzEeuZRma+oLp28a3CGoaPvlPltyW5E2G9rhs+15nOr4zYME5Wgs8o6tax6ke9lHNqPWIRRwGOOe44V1XrHPnHLhnJ8VXM8t2EiiEG5kKzuMJvbeWRjQE/Z4ti+yagffh44UWbBz9lJ9+dt7A/3ZzMGyR7xJP0OBJG2n8eOOq5yv2jC+nbCs+4PLPO/7YILh93pXyuy3xqPY1HxL4u5by570c2BxcYE4iPLSfop1zio3JcIddf1G7pVHBgUY+EXhv5XPpswe9yXmEu57wp/2/2Dm16/E8Fjrrs88uHUhInyKFQu/YXum+u+eQ+AgQuLzSYWeZNtAPUk/5VDqXnM9boZ9astfQhPz7oiGtVp3UjCZcFpLqZzYqxXej34648NiwmJHPzHhuGFch4wAxnsZ/UbS4y1HHjQqbxfruf+4Dr8TrbYKkOIwmYwLISk5cQW+o0wyNVPkSug4BuiDwvTs55IexG6Tdqv1i0IKG/4+MOOR4oqFQIIDfVHJybpF02D70HXXck/OlEKQGioP3tCjg9u3CggB+c6qO7G/WdPjIYCEfDYxwXM9fzDO8P9ZKLu1uoP7xgN/aefAJJc3Vpy5Gi/Nam7tf7TT0Zj+eNjbDTduDie7272ac9m7/HN8cfHsiQgcXMG+Nq7BwEgHx7xKS7HMn/+bseB1BHu99HmYISbNrdhf/k3Sf/s52b9A4wjB/MjcaCRBoIooxc3S44LbkPfjRx/jgVAaBOBODbwoLJ/fKyQwoDw3OtucqnuxggeNDYONEqGdXPWnupuCDeliMYOIDSBINbdGoAHjU2EsxQGyicGdbfxhLiuCXhrTkn6Z+EvJBtHF5ISf0Rx4kmTOJOsP51x9xNpQnPJ+tGcux9JEzuerG3UQtsn3f1MSfofF1xOxk+Xk9SZv/8pgPhhMj66kGym/3RlXJSMRy/eX8ZiUBIAp5LhaCzZlM1O9onxwWQwvUjd57NtbBStVee0y0Q77b/xxhur+jp9+jT3OsfXX399ZuvWrb/SOycUNfRsVM+IcvhFwb+99957tz/99NOku02quX6DiqK+z4alUTPSEZOdm5vz7RgYzzzzjL9+9dVX3fz8fDQ7O5towv760qVLlaNHj/qJvPnmm5HOfVu67zg/fPjwryqVyn/26i+O439/6623/vvpp59OHnzwQd/HDz/84Nvi2s6hGzduJPRHv0YArjH6Oiwo5wHUKEkn4walQbY17+EmANMAIw0sOnYs/TD7888/j3bv3h0JRHf16tXo66+/jmZmZly9Xnc7duzw74nT/PH69ev+nW3btkW7du1Kpqenqe9eeuml/Q899NDvNKH9fpBRdHVxcfFfz5079/Hjjz/eGdPy8nIHsKWlpeSrr75y6juxfh544IGY448//pg89dRTvq6BDMAcBXISJGEVd5bl1rIb65GBBncB2Msvv+yvv/jii+jOnTs+KcHAb926FQEIIG3ZssUXTSDav39/IsB8PYHlrl27Fk1NTUUCyn3//feOY6vVSgSUvyfQd+qd/2IiV65c+Q8twG217yel/iLegbZv3+7vNZvNJIDWuV5ZWfHnO3fuTL788suERQJovZ9oIZLHHnvMA4xEiBHgWAMtyQC56nogAA24oFsixNFE55NPPqlqgBXA0oQrmlwFoABHnFHhWa1Wi6rVaqRB+3e6rzV5J8Ac96xPvefP1a5rNBr3jEkLkmTfbbfbiZ1r0RKuec5i2Ln6jfVe/O2331I32bt3byzpiAFT78RwKlwqAGOA5B3EXaopCeBFrg+IhQCqwYrpLu5JBKpif96rqmMArGigHkytekUD514VUDgXRbofqU4lAOP75B5Hnmf7tPv9SFy7aiLSi51r9RnbPQp1OQKkOKmt61iLG3MUeB5U9d/We23UgYBuw5WIOSKe1Zn9RLrfXzL39wP3ce6BRFT37dtXFWfAXTWtek16C5BqeqfKHDSoqgZXDcD4I+CpROi4KMiEwI26wQsD7Tcmb7EEMIuQ8D73skBCGlZiAAKo+og5V/1Y3NbWQrfVBuCxuhpWuyWpat2+fbvNtc7jRx99NBaAsYEoToyDBzAYgICmxiI15MF75JFHGE0V8DSQKYCbQpFFEb/6rGlg/qiBVwxQjkxcxwpHgFQbLIDvKwDs+0M8de7sOgsmQHAtIOC0e4DjnPsQ+g8ug3hP7cGZbbrX45aetbTILT1u6Z2m+m1KhNtijqbmSf1WL07sxYU9/+hEOt8kCm4IitlzYRY8SKeMcosGOSUR8EcApB7ngId4w6IGIIAh3swtAOJF3cChnp7x3FwL3skq9Ridxr1wH27z96kfQLNjrDY9cOqzBXiQzlcMOMbDGNRmE65jzeQJsPhwehsMsNL9RLiWw4GIrZP5j2QBIxmJKoZC4gsgNXUKgNMwjs63aEDTem+LAIMzARYgqeO5MIDqAsCekwELgPV+LYg5QHtuDUfjRL/6AbAY0Qz6Dr3WtiNgAW6csiWc5IHTc8S1pcsVqZGmGAA+WAZLJIF+ZFxi7iMBuEICMX7uueciMyphLUtzIM6xk2/n3RHcE9yRdDxVRHVK9xBXgJpW2arzaT0DwK3qbErNTOma5x5MJAxO4xyQNdgtiLzOeacW7vPci38YsIV6Jj6eqxBBFD+cBefouqm2PVehJgGM5wCLRAOk2gW1Fd1bFogrGDy8AoCmbaSKc3FdHPqNcNFQYfi0ro8V7seB3kHmHGdY+qKiVYH7OhOEA/UYq4AV2QqIKtu4hhO5BiQABxz0u96ZZqAq21SmNQlfaCuIey2IcMWkwIYUOLDDeXAU4CGGAnCJAlfp2hf0mwogr6AdVJbV1xLSowIjVAIo6F0v6gLWGxmYRX5mZWFhAYPiukPGQgCN8PnwxZ588kk/GSwunCRF640F7wOWAQb3AaYGAxcCKOI9HbjPn2sxtsl675DO3K4JbQNAONJEmmPQf90GDgsLd8SBE+E+r88kJYua9KLEcFHvLurdZUQX0OBI1V2h3aB7jaPjoMOphzeBB+GNpeZdwT9k/kRWBA8D6UDcl8C2KFSv0OW5e2tphkArhXWtAiq6xACFmxBrnW8VOIDLOVwH920DOIH4AIVrANQ9b3gQYZzwULw11qT9OHCS8dsouCqIaOA+uM3r3ozoo9uW9VolcBpGosO5gSu9WoHbca9YPFliL9ZEOnCejj4+lyi7fm5MTwDxwN99991ObeJIlO13333nbBUh3AYsp+mqAK4HlILYhlINRgX96Y0OuhGw0acCawrwcKLFnUwEX9KsMs6z0yQTeQNt6V50YBKA8dYXbgxA0g7tYnG9QUEtoCvDInsPILhV5iD7sWN3FFERSnZwINwjySH15fpRrgjjB9GIzLsPneACiXQcHNR22m/sfStbXXwortE7Lt24rwSwm94CiTNwgbC84ZrYOTYORIx03QrRi58fi8diCUSLHhgDoOHTrQT9t4Lu032KNxjoyHbaiPf3XGpU0I1eDeAv4lAThWDhiZHNCWfOWjBH5ufixYvD6UCIGJGYUasQG3h0GiwbipwBMbilAIJX0MHl8H4X1hpdFED14KKX9O6ScWOwxNXg4nida+ky3B8sJG3CcebX0TdtCNgldGAoDQANQNIP/XK+xBjVjweZ+7pe0Zw8wMxJKsUvDpzLPJk7MXlIzw0WC6MT5ESjUDHnNXVQEwdOBbdji1nf4LZgfTnHKm/X61hWztFLuDO1ANQWLLMKFnob9bHKwdh4kQe8ShpjVW3QgGhuDADCfQEcFgEubAQQPSdyPywSC7YSjArHJd2nNJAE9dEIwHK+ZPWkJpryfVvyA9vSgXHot7wRMbKcGaytlJAXW5n3dogjYbOVlMFSNUIwriP6xotpsNA404ix14H4hnp/ysA0H9C4V/UolRBddPRtCOWyHNgOourdGQBBTBmjqZJgMJr4ggCJEw2I+Ixwo87xBwEW0FriuBYONakvVFcXQ5V3pIMLYWkc8nyxgm2c6VgdwOqd7Aq6GKuISKNfGKwG6o2FJRlS3V2FgyuB0zAYcHU1+IfePQptequZRmIVF4BMghgzJoDrcCIRCP1yDmCIutXRsRX0sxdljdvrTPXLwgNcM3Arjjg+ZUwsjAsTxNdn0sl/klDohVVe6iiSJfbJBMT4m2++8ZPvTiYILDjJkgg+wiB8y4Zx6EQ4DX2OkcjEwVVyESHB4COdEMZh9X2MzDm6z9yZAI7P9wFaEijoLjItPi2FocA5NoDTPEYbtwfuxLg0LYqB80JcjPS0LK2F+Mqls0SC55dSHGicJSLB6DmNFWF1lJHxGWV56c6CdvIK+HIMSKvnfazATT7OTedXMd0WhfsWqpmvh68WBd+PdisGGtfcT9LV8FYStwY3B+43AEl1hYyLRSyAaDFzyzwG1s6AJSsj8NoGnpKuxMTxiy++GGf3U/pyWd7DTFIhynKidERV5t1zJGIpdweR7aSwNDifGED3hRDNAIxCGOhzg+aYZ3ODXAOEkd23FJb5b4AIeKGOZWJ8DtCOgBfE3fuEWmR/BDgSq0FftnGjNAcy1iQQ2u+//34iyzt8QjUDYLZOB8hsfpA4WXk07lXJTsNFMjQ+QsEZRmQNQJxYy1AboAaQHXnWLytt2WiORCqWjc5mooObRU4QJ9pno+EoPW5bNIM7BqgARwL1s88+YyPKEqmJxb5F4Plxuxyy0CU04BsO24Vtbfq0SEDq/soHH3zQktVaDv7WsgaKS9F4+OGH8ckaxKeqtyjQFzV4H7Oqrj/X/TsCzx8FCrHsHbXxo96/o8n7cys8o1CX9rRId8Rld2iLulxbu1q8Buda0IZ82AYujt71Y2Ss2vxqyjA2tZPnEwiaWyyHOWZfpCx4hQBmG+CIJQqr4zsLPlL7yJEjTW0ykRbn2NTKrmiAKwJ7WYNb0uouaaWXtMINKeeGPPyGwGwIuIYAWFKdhnQqGZWGFUDVe4tkULL3AYX6HAWYbyM4zw18OfqjL/rE4gIaLs6zzz67cujQoeUwxhYMAGiMnyCBORlohLLBZSrc2hx6Y707W2L7J6Z4EXWOiDvH7n3isDHlnnjiCXfz5s1OW+hGO2ePGF2kLdBV97P7wXv27EGckYwouw9sz7WQCeFYZnPf7wNDABWSBKX2gHvROD/tiJJk9Ths998sOWRfK9g1homAHQqZD/+MibNBTyLD7hkZKKSaQqzqbGMfQs0Alriuo8symZShwepFfwF243Z/7wkupgAAAABJRU5ErkJggg==';
        // eslint-disable-next-line max-len
        const offline = 'data:image/png;base64,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';
        // eslint-disable-next-line max-len
        const assist = 'data:image/png;base64,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';
        // eslint-disable-next-line max-len
        const using = 'data:image/png;base64,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';
        const iconMap = { using, charging, offline, assist, idle };
        const marker = new window.google.maps.Marker({
          position: position,
          icon: {
            url: iconMap[point.currentState],
            scaledSize: new window.google.maps.Size(40, 58),
          },
        });
        point.marker = marker;
        marker.addListener('click', () => {
          _this.openGoogleInfoWindow(Object.assign({}, point, position), marker);
        });
        return marker;
      });
      const markerCluster = new MarkerClusterer(map, markers, {
        clusterClass: 'map-cluster-g-marker',
        origin: new window.google.maps.Point(0, -30),
        anchor: new window.google.maps.Point(0, -26),
        styles: [
          MarkerClusterer.withDefaultStyle({
            width: 18,
            height: 34,
            textColor: '#ffffff',
            textSize: 10,
            textLineHeight: 26,
            textAlign: 'center',
          }),
        ],
      });

      console.warn(markerCluster);
    },
    // 选择行事件
    onClickRow: function (row) {
      if (!row.lng || !row.lat) {
        this.$refs.tb1.$emit('setCurrentRow');
        return;
      }
      if (this.current.deviceId === row.deviceId) {
        this.$refs.tb1.$emit('setCurrentRow');
        this.current = {};
        // 高德地图
        if (`${this.mapType}` === '1') {
          map.setZoom(5);
          showInfoWindow.close(map);
          setTimeout(() => {
            map.setCenter([104.937478, 35.439575]);
          }, 200);
        } else if (`${this.mapType}` === '4') {
          // 谷歌地图
          map.setZoom(3);
          map.setCenter({ lat: 30.344, lng: 16.036 });
          if (showMarker) {
            showMarker.setMap(null);
          }
        }
        return;
      }
      this.current = row || {};
      // 高德地图
      if (`${this.mapType}` === '1') {
        if (showMarker) {
          showMarker.setMap(null);
        }
        map.setZoom(15);
        const point = this.wgs_gcj_encrypts(row.lat, row.lng);
        setTimeout(() => {
          map.setCenter([point.lon, point.lat]);
        }, 200);
        row.lnglat = [point.lon, point.lat];
        this.openInfoWindow(row);
      } else if (`${this.mapType}` === '4') {
        // 谷歌地图
        map.setZoom(15);
        let position;
        // 国内/香港/澳门需要做坐标转换
        if (this.mapRegion === 'HK' || this.mapRegion === 'CN' || this.mapRegion === 'MO') {
          const wgs = this.wgs_gcj_encrypts(row.lat, row.lng);
          position = { lat: wgs.lat, lng: wgs.lon };
        } else {
          position = { lat: row.lat, lng: row.lng };
        }

        setTimeout(() => {
          map.setCenter({ lng: row.lng, lat: row.lat });
        }, 200);
        const marker = new window.google.maps.Marker({
          position: position,
          map: map,
          icon: {
            url: 'http://ice-i-synergy.oss-cn-shenzhen.aliyuncs.com/attachment/dev/WechatIMG406 2.png',
            scaledSize: new window.google.maps.Size(41, 58),
          },
        });
        showMarker = marker;
        this.openGoogleInfoWindow(Object.assign({}, row, position), marker);
      }
    },
    // 获取设备数量
    getDeviceCount: function () {
      this.$getJSON(apis.MyDeviceCount).then(async (res) => {
        const result = res.data;
        result.productCountList = await this.formatAttachList(result.productCountList, 'productCodeId', 'dms.product.icon');
        this.count = result;
      });
    },
    // 逆地理编码(高德单个)
    getGeoCode: async function (lnglat) {
      return new Promise((resolve, reject) => {
        if (!lnglat) {
          reject();
          return;
        }
        window.AMap.plugin('AMap.Geocoder', () => {
          const Geocoder = new window.AMap.Geocoder();
          Geocoder.getAddress(lnglat, (status, result) => {
            if (status === 'complete' && result.info === 'OK') {
              resolve(result.regeocode.formattedAddress);
            } else {
              reject();
            }
          });
        });
      });
    },
    // 逆地理编码(谷歌、单个)
    getGoogleCode: async function (item) {
      return new Promise((resolve, reject) => {
        if (!item.lat || !item.lng) {
          reject();
          return;
        }
        const geocoder = new window.google.maps.Geocoder();
        geocoder.geocode({ location: new window.google.maps.LatLng(item.lat, item.lng) }, (results, status) => {
          // 这里处理结果和上面一模一样
          if (status === window.google.maps.GeocoderStatus.OK) {
            resolve(results[0].formatted_address);
          } else {
            reject();
          }
        });
      });
    },
    // 地图缩放
    toolHandle: function (type) {
      if (type === 'add') {
        const zoom = map.getZoom();
        map.setZoom(zoom + 0.8);
      }
      if (type === 'reduce') {
        const zoom = map.getZoom();
        map.setZoom(zoom - 0.8);
      }
    },
    // 筛选设备状态
    onStateItem: function (code) {
      this.visibleRightSide = true;
      if (this.formSearch.state === code) {
        this.formSearch.state = '';
      } else {
        this.formSearch.state = code;
      }
      this.totalRows = 0;
      this.devicePageList = [];
      this.getDeviceList();
      this.getDeviceCount();
      this.onPageChange({ page: 1 });
    },
    onOtherStateItem: function (code) {
      if (this.otherState.includes(code)) {
        this.otherState = this.otherState.filter((t) => t !== code);
      } else {
        this.otherState.push(code);
      }
      this.getDeviceList();
      this.onPageChange({ page: 1 });
    },
    onProductItem: function (code) {
      if (this.productCode.includes(code)) {
        this.productCode = this.productCode.filter((t) => t !== code);
      } else {
        this.productCode.push(code);
      }
      this.getDeviceList();
      this.onPageChange({ page: 1 });
    },
    // 设备过滤
    filterHandler: function (value) {
      this.formSearch = Object.assign(this.formSearch, value);
      this.onPageChange({ page: 1 });
    },
    // 分页变更
    onPageChange2(page) {
      this.onPageChange({ page });
    },
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getDevicePage();
    },
  },
};
</script>

<style lang="scss">
.amap-logo,
.amap-copyright {
  display: none !important;
}

.menu-map .el-dropdown-menu__item {
  font-weight: bold;
  color: #4d4d4d;
  font-size: 12px;
  height: 32px;
  line-height: 32px;
  margin: 0 8px;
  padding: 0 8px;
  &:hover {
    background: none;
  }
  &.cur {
    color: #ffffff;
    border-radius: 8px;
    background-color: #00a0d9;
  }
}

.drawer-left-container {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 262px;
  .drawer-left-wrap {
    position: relative;
    width: 100%;
    height: 100%;
    padding: 16px 16px 16px 0;
    background-color: #ffffff;
    .tit {
      cursor: pointer;
      line-height: 40px;
      height: 40px;
      border-radius: 8px;
      padding: 0 8px;
      font-weight: bold;
      img {
        width: 18px;
        margin-right: 16px;
      }
      &.cur {
        color: #ffffff;
        background-color: #00a0d9;
      }
    }
    .sub-tit {
      color: #818181;
      height: 24px;
      line-height: 24px;
      font-size: 12px;
      margin-top: 8px;
      margin-bottom: 8px;
      padding-left: 40px;
    }
    .states {
      ul li {
        line-height: 30px;
        color: #4d4d4d;
        font-size: 12px;
        margin-bottom: 2px;
        cursor: pointer;
        & > .ub {
          padding: 0 8px;
          height: 30px;
          border-radius: 8px;
          &:hover {
            background-color: #f7f7f7;
            color: #4d4d4d;
            .label {
              padding-left: 3px;
            }
          }
        }
        .cur {
          background-color: #00a0d9;
          color: #ffffff;
          &.ub:hover {
            background-color: #00a0d9;
            color: #ffffff;
          }
          .dit {
            width: 18px;
            height: 18px;
            margin-left: 0;
            margin-right: 16px;
            border: 4px solid #ffffff;
          }
          .rect {
            background-color: #ffffff !important;
          }
          .label,
          .icon {
            color: #ffffff;
          }
        }
        .idle .dit {
          background-color: #00A0D9;
        }
        .using .dit {
          background-color: #93DA49;
        }
        .charging .dit {
          background-color: #ffad00;
        }
        // .training .dit {
        //   background-color: #3fe65e;
        // }
        // .autonomous .dit {
        //   background-color: #4641d8;
        // }
        .assist .dit {
          background-color: rgb(226, 69, 69);
        }
        .dit {
          display: inline-block;
          width: 10px;
          height: 10px;
          border-radius: 10px;
          background-color: #b3b3b3;
          margin-left: 4px;
          margin-right: 20px;
        }
        .running .rect {
          background-color: #93DA49;
        }
        .autonomous .rect {
          background-color: #93DA49;
        }
        .training .rect {
          background-color: #93DA49;
        }
        .rect {
          display: inline-block;
          width: 4px;
          height: 4px;
          background-color: #00a0d9;
          margin-left: 24px;
          margin-right: 14px;
        }
        .label {
          font-weight: bold;
          font-size: 12px;
          color: #4d4d4d;
          padding-left: 0;
          transition: padding-left 0.3s;
        }
      }
    }
    .types {
      ul li {
        height: 30px;
        line-height: 30px;
        padding: 0 8px;
        color: #4d4d4d;
        font-size: 12px;
        margin-bottom: 2px;
        border-radius: 8px;
        cursor: pointer;
        .label {
          font-weight: bold;
        }
        .img-box {
          width: 18px;
          height: 18px;
          border-radius: 4px;
          margin-right: 16px;
          padding: 0.5px;
          overflow: hidden;
          img {
            width: 100%;
            height: 100%;
            display: block;
          }
        }
        &:hover {
          background-color: #f7f7f7;
          color: #4d4d4d;
        }
        &.cur {
          background-color: #00a0d9;

          color: #ffffff;
          .label {
            color: #ffffff;
          }
          .img-box {
            background-color: #ffffff;
          }
        }
      }
    }
  }
}
.drawer-left-btn {
  width: 16px;
  height: 70px;
  line-height: 70px;
  text-align: center;
  cursor: pointer;
  position: absolute;
  top: 50%;
  right: 0;
  transform: translate(100%, -50%);
  background-image: url('~@/images/map/rectangle2.svg');
  background-size: 100% 100%;
  &.show {
    left: 0;
    right: auto;
    transform: translate(0, -50%);
  }
  i {
    display: block;
    font-size: 12px;
    color: #1a1a1a;
    transform: scale(0.8);
    &.show {
      transform: rotate(180deg) scale(0.8);
    }
  }
}

.drawer-right-container {
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  width: 284px;
  .drawer-right-wrap {
    position: relative;
    width: 100%;
    height: 100%;
    padding: 16px 0 16px 16px;
    background-color: #ffffff;
    .tit {
      height: 40px;
      line-height: 40px;
      font-weight: bold;
      color: #202945;
      font-size: 16px;
    }
    .filter {
      margin: 24px 0;
      .el-input__inner {
        border-radius: 36px;
      }
    }
    .devices {
      overflow: auto;
      ul li {
        height: 64px;
        border: 1px solid #f0f0f0;
        padding: 12px 10px 10px;
        border-radius: 8px;
        margin-bottom: 12px;
        cursor: pointer;
        .box {
          width: 32px;
          height: 32px;
          margin-right: 10px;
        }
        h1 {
          line-height: 20px;
          color: #1a1a1a;
          font-weight: bold;
          font-size: 12px;
          padding-left: 2px;
          span {
            color: #818181;
            margin-left: 8px;
          }
        }
        .about {
          margin-top: 2px;
          line-height: 20px;
          font-size: 12px;
          font-weight: bold;
          display: flex;
          & > span {
            width: 52px;
            i {
              margin-right: 2px;
              font-size: 14px;
              color: #00a0d9;
              font-weight: normal;
            }
          }
          .eco,
          .lock,
          .err {
            width: auto;
            margin: 0 3.2px;
          }
          .eco i {
            font-size: 17px;
            color: #93da49;
          }
          .lock i {
            font-size: 17px;
            color: #818181;
          }
          .err i {
            font-size: 17px;
            color: #eb5a5a;
          }
        }
      }
    }
    .pages {
      padding-top: 24px;
      .el-pagination {
        border: 1px solid #e4ebf2;
        padding: 7px 5px;
        border-radius: 40px;
      }
    }
  }
}
.drawer-right-btn {
  width: 16px;
  height: 70px;
  line-height: 70px;
  text-align: center;
  cursor: pointer;
  position: absolute;
  top: 50%;
  left: 0;
  transform: translate(-100%, -50%);
  background-image: url('~@/images/map/rectangle.svg');
  background-size: 100% 100%;
  &.show {
    right: 0;
    left: auto;
    transform: translate(0, -50%);
  }
  i {
    display: block;
    font-size: 12px;
    color: #1a1a1a;
    transform: rotate(180deg) scale(0.8);
    &.show {
      transform: scale(0.8);
    }
  }
}

.map-marker {
  position: relative;
  z-index: 10;
  .marker {
    margin: 0 auto;
    width: 40px;
    height: 58px;
    // transform: translate(-50%, -50%);
    // background: #b3b3b3;
    // border: 4px solid #ffffff;
    // border-radius: 18px;
    background-image: url('../../../images/map/device_offline.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;

    &.charging {
      background-image: url('../../../images/map/device_charging.png');
      // background-color: #ffad00;
    }
    &.using {
      background-image: url('../../../images/map/device_using.png');
      // background-color: #00a0d9;
    }
    &.idle {
      background-image: url('../../../images/map/device_idle.png');
      // background-color: #4d4d4d;
    }
    &.assist {
      background-image: url('../../../images/map/device_assist.png');
      // background-color: #e24545;
    }
    &.autonomous {
      background-image: url('../../../images/map/device_using.png');
      // background-color: #93DA49;
    }
    &.running {
      background-image: url('../../../images/map/device_using.png');
      // background-color: #93DA49;
    }
    &.training {
      background-image: url('../../../images/map/device_using.png');
      // background-color: #93DA49;
    }
  }
}

.device-aside .info .icon-machine-offline {
  font-size: 18px !important;
}

.map-cluster-g-marker {
  background: #0c89c7;
  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.2);
  font-size: 18px;
  color: #ffffff;
  line-height: 25px;
  padding: 4px 14px;
  border-radius: 8px;
  width: auto !important;
  transform: translateY(-20px);
  & > div {
    min-width: 18px;
    position: relative !important;
    width: auto !important;
    &:active,
    &:visited,
    &:hover {
      border: none;
      outline: none;
    }
  }
  &::after {
    content: '';
    position: absolute;
    top: 33px;
    left: 50%;
    transform: translateX(-50%);
    border: 6px solid transparent;
    border-top: 6px solid #0c89c7;
    width: 0;
    height: 0px;
  }
  &::before {
    content: '';
    width: 32px;
    height: 14px;
    background-image: url('../../../images/map/block.png');
    background-repeat: no-repeat;
    background-size: 100%;
    position: absolute;
    top: 40px;
    left: 50%;
    transform: translateX(-50%);
  }
}

.map-cluster-marker {
  position: relative;
  z-index: 12;
  .marker {
    position: absolute;
    z-index: 12;
    top: -40px;
    left: 50%;
    transform: translateX(-50%);
    .marker-num {
      background: #00a0d9;
      box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.2);
      font-size: 16px;
      color: #ffffff;
      line-height: 25px;
      padding: 4px 14px;
      border-radius: 8px;
      position: relative;
      &::after {
        content: '';
        position: absolute;
        top: 33px;
        left: 50%;
        transform: translateX(-50%);
        border: 6px solid transparent;
        border-top: 6px solid #00a0d9;
        width: 0;
        height: 0px;
      }
    }
  }

  .marker-block {
    width: 32px;
    height: 14px;
    background-image: url('../../../images/map/block.png');
    background-repeat: no-repeat;
    background-size: 100%;
  }
}

.device-map-bd .amap-info-sharp {
  border-top: 8px solid #f5f5f5 !important;
}

.device-map-bd .amap-info-content {
  padding: 10px;
  border-radius: 8px;
  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.2);
}
.device-maps-bd {
  height: 100%;
  background-color: #ffffff;
}

.device-map-bd {
  height: 100%;
  position: relative;
  overflow: hidden;
  padding: 16px 0;
  margin: 0 16px;

  .el-table__row.exit td {
    background-color: #fafafa;
  }
  .el-table__row.exit .cell {
    color: #666;
  }
  .gm-style .gm-style-iw-c {
    border-radius: 8px;
    box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.2);
  }
  .gm-style-iw-chr {
    height: 20px !important;
  }

  .gm-ui-hover-effect {
    // height: 20px !important;
    top: 0px !important;
    right: 0px !important;
  }
  .gm-style .gm-style-iw-t::after {
    background: #f5f5f5 !important;
    width: 14px !important;
    height: 14px !important;
  }
  .gm-style .gm-style-iw-tc::after {
    background: #f5f5f5 !important;
  }

  .gm-style-mtc button {
    font-size: 14px !important;
  }
  .gm-control-active img {
    width: 14px !important;
    height: 14px !important;
  }
}

.device-map-bd {
  .full-btn {
    position: absolute;
    right: 16px;
    top: 16px;
    z-index: 190;
    width: 36px;
    height: 36px;
    cursor: pointer;
    background-color: #ffffff;
    color: #495057;
    line-height: 36px;
    text-align: center;
    box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.1);
    border-radius: 2px;
    .icon {
      font-size: 16px;
    }
  }
  .full-screen {
    position: fixed !important;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 999;
    height: auto;
    margin: 0;
    padding: 0;
  }
  .table-wrap {
    overflow: hidden;
    padding: 0 10px;
  }
  display: flex;
  .el-table__header tr th {
    background-color: #ffffff !important;
  }
  .table-page {
    background-color: #ffffff;
  }
  .el-input__inner {
    border: 1px solid rgba(228, 235, 242, 1);
  }
  .device-aside {
    width: 425px;
    flex-direction: column;
    background-color: #ffffff;
    overflow: hidden;
    margin-right: 16px;
    position: relative;
    .info {
      padding: 24px 24px 16px;
      position: relative;
      border-bottom: 1px solid #eef2f8;
      h1 {
        color: #495057;
        font-size: 12px;
        line-height: 17px;
        margin-bottom: 8px;
      }
      p {
        font-weight: bold;
        color: #394668;
        font-size: 26px;
        line-height: 28px;
        margin-bottom: 26px;
      }
      ul li {
        line-height: 26px;
        height: 28px;
        margin-right: 8px;
        padding: 0 8px;
        color: #6c757d;
        font-size: 12px;
        width: 120px;
        margin-bottom: 8px;
        border-radius: 2px;
        background: rgba(249, 249, 253, 1);
        border: 1px solid rgba(228, 235, 242, 1);
        cursor: pointer;
        &:nth-child(3n) {
          margin-right: 0;
        }
        &.cur {
          background-color: #0d9ae0;
          border: 1px solid #0d9ae0;
          color: #ffffff;
        }
        .icon {
          font-size: 12px;
          margin-right: 8px;
        }
        span {
          vertical-align: top;
          font-size: 12px;
          width: 60px;
          display: inline-block;
          &.num {
            float: right;
            width: auto;
          }
        }
      }
    }
    .about {
      span {
        color: #6c757d;
        font-size: 12px;
        margin-right: 6px;
        display: inline-block;
        width: 52px;
      }
      .icon {
        color: #12c469;
        font-size: 14px;
        margin-right: 1px;
        float: left;
      }
    }
    .side-box {
      height: calc(100% - 85px);
      .model-list {
        background-color: #f2fbfd;
        height: 100%;
        overflow-y: auto;
        li {
          padding: 11px 13px;
          height: 70px;
          cursor: pointer;
          &.cur {
            background-color: #ffffff;
          }
        }
        .img-box {
          width: 48px;
          height: 48px;
          margin-right: 12px;
          text-align: center;
          line-height: 48px;
          img {
            display: block;
            width: 100%;
            height: 100%;
          }
          .icon {
            color: #7fcaee;
            font-size: 30px;
          }
        }
        .name {
          h1 {
            font-size: 12px;
            color: #495057;
            line-height: 26px;
            font-weight: 500;
          }
          p {
            color: #98a6ad;
            font-size: 12px;
            line-height: 22px;
          }
        }
      }
    }
  }
  .product {
    width: 240px;
    padding-bottom: 46px;
    .img-box {
      width: 32px;
      height: 32px;
      img {
        width: 100%;
      }
    }
    .info {
      padding-left: 10px;
      h1 {
        cursor: pointer;
        color: #1a1a1a;
        line-height: 20px;
        font-size: 12px;
        margin-bottom: 2px;
        font-weight: bold;
        padding-left: 2px;
        span {
          color: #818181;
          margin-left: 6px;
        }
        &:hover {
          color: #00a0d9;
        }
      }
    }
    .about {
      line-height: 20px;
      height: 20px;
      .icon {
        color: #00a0d9;
        font-size: 12px;
        margin-right: 2px;
      }
      span {
        display: block;
        width: 38px;
        color: #4d4d4d;
        font-size: 12px;
        font-weight: bold;
      }
      .eco .icon {
        font-size: 18px;
        color: #93da49;
        margin-right: 4px;
      }
      .lock .icon {
        font-size: 18px;
        color: #818181;
      }
      .err .icon {
        font-size: 18px;
        color: #eb5a5a;
      }
    }
    .loc-wrap {
      height: 48px;
      background: #f5f5f5;
      position: absolute;
      left: 0;
      bottom: 0;
      right: 0;
      padding: 6px 12px;
      // .icon-loc {
      //   width: 18px;
      //   height: 18px;
      //   overflow: hidden;
      //   background-image: url('../../../images/map/location.png');
      //   background-repeat: no-repeat;
      //   background-size: 100%;
      //   margin-right: 8px;
      //   margin-top: 4px;
      // }
      .location {
        flex: 1;
        width: 0;
        color: #4d4d4d;
        line-height: 18px;
        font-size: 12px;
        display: flex;
        align-items: center;
      }
    }
  }
  .amap-tool {
    position: absolute;
    right: 16px;
    bottom: 16px;
    z-index: 199;
    .zoom {
      box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.1);
      border-radius: 2px;
      margin-top: 10px;
      width: 32px;
      background-color: #ffffff;
      text-align: center;
      align-items: center;
      .icon {
        cursor: pointer;
        color: #646464;
        font-size: 16px;
        line-height: 37px;
      }
      .bar {
        background-color: rgba(0, 0, 0, 0.1);
        height: 1px;
        width: 24px;
      }
    }
  }
  .device-section {
    height: 100%;
    overflow: auto;
    position: relative;
    .device {
      padding: 4px 2px 4px 6px;
      h1 {
        color: #495057;
        font-size: 12px;
        font-weight: 500;
        line-height: 17px;
        margin-bottom: 4px;
      }
      p {
        min-width: 100px;
        color: #6c757d;
        font-size: 12px;
        line-height: 17px;
      }
    }
    .status-box {
      position: absolute;
      left: 16px;
      top: 16px;
      z-index: 190;
      .ub {
        height: 40px;
        line-height: 40px;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.15);
        border-radius: 2px;
        li {
          padding: 0 16px;
          position: relative;
          &.cur span,
          &.cur .icon {
            color: #0d9ae0;
          }
          &:last-child::after {
            content: '';
            opacity: 0;
          }
          &::after {
            content: '';
            position: absolute;
            right: 0;
            width: 1px;
            background-color: #e9ebec;
            height: 16px;
            top: 50%;
            transform: translateY(-50%);
          }

          .icon {
            color: #6c757d;
            font-size: 12px;
            margin-right: 6px;
            vertical-align: top;
          }
          span {
            vertical-align: top;
            color: #6c757d;
            font-size: 12px;
          }
        }
      }
    }

    .tab-box {
      position: absolute;
      left: 16px;
      top: 16px;
      z-index: 190;
      .ub {
        border-radius: 2px;
        overflow: hidden;
        box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.1);
      }
      .ub-f1 {
        background-color: #ffffff;
        line-height: 40px;
        height: 40px;
        padding: 0 15px;
        color: #6c757d;
        font-size: 12px;
        cursor: pointer;
        &.cur {
          background-color: #0d9ae0;
          color: #ffffff;
        }
      }
    }
  }
  .amap-container {
    border: none !important;
  }
  .device-models {
    width: 280px;
    background-color: #ffffff;
    border-radius: 2px;
    margin-left: 16px;
    .title {
      background: rgba(242, 251, 253, 1);
      padding: 0 16px 16px;
      h1 {
        line-height: 40px;
        height: 40px;
        color: #495057;
        font-size: 12px;
        font-weight: 500;
        span {
          color: #6c757d;
        }
      }
    }
    .model-list {
      height: calc(100% - 108px);
      overflow-y: auto;
      ul li {
        height: 76px;
        padding: 10px 12px;
        cursor: pointer;
        &.cur {
          background: rgba(242, 251, 253, 1);
          border: 1px solid rgba(13, 154, 224, 1);
        }
        .img-box {
          width: 56px;
          height: 56px;
          margin-right: 16px;
          img {
            display: block;
            width: 100%;
            height: 100%;
          }
        }
        .info {
          font-size: 14px;
          color: #495057;
          h1 {
            font-weight: 500;
            margin-bottom: 2px;
            line-height: 17px;
          }
          p {
            color: #98a6ad;
            font-size: 11px;
            line-height: 16px;
            margin-bottom: 6px;
          }
        }
        .about {
          span {
            color: #495057;
            font-size: 12px;
            margin-right: 4px;
            display: inline-block;
            width: 48px;
          }
          .icon {
            color: #12c469;
            font-size: 14px;
            margin-right: 2px;
          }
        }
      }
    }
  }
}
</style>
